import type { AddressDto } from '@roadfootage/api-client'
import { AddressPrecision } from '@roadfootage/api-client'

export interface NominatimSearchResult {
  display_name: string
  boundingbox: [string, string, string, string]
  lat: string
  lon: string
}

export async function searchLocations(query: string): Promise<NominatimSearchResult[]> {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?format=json&limit=5&q=${encodeURIComponent(query)}`
  )
  return res.json()
}

export async function reverseGeocodeToAddressDto(lat: number, lng: number): Promise<AddressDto> {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&lat=${lat}&lon=${lng}`
  )
  const data = await res.json()
  const addr = data.address ?? {}
  return {
    rawInput: data.display_name ?? null,
    formattedAddress: data.display_name ?? null,
    streetNumber: addr.house_number ?? null,
    streetName: addr.road ?? null,
    suburb: addr.suburb ?? addr.quarter ?? null,
    state: addr.state ?? null,
    postcode: addr.postcode ?? null,
    country: addr.country ?? null,
    precision: AddressPrecision.Approximate
  }
}

export async function reverseGeocodeToDisplayName(
  lat: number,
  lng: number
): Promise<string | null> {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&zoom=16&lat=${lat}&lon=${lng}`
  )
  const data = await res.json()
  const addr = data.address
  const road = addr?.road
  const locality = addr?.suburb ?? addr?.city_district ?? addr?.quarter ?? addr?.town ?? addr?.city
  return [road, locality].filter(Boolean).join(', ') || null
}
